import { Chart, registerables } from 'chart.js';
import { Base } from '@studiometa/js-toolkit';

// Register necessary components manually
Chart.register(...registerables);

/**
 * Chart component
 */
export default class Charts extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Chart',
    options: {
      data: {
        default: () => {},
        type: Object,
      },
      firstname: {
        type: String,
        default: '',
      },
    },
  };

  /**
   * Mounted hook
   */
  mounted() {
    // eslint-disable-next-line no-new, no-unused-vars
    const chart = new Chart(this.$el, {
      type: 'bar',
      data: {
        labels: Object.keys(this.$options.data),
        datasets: [
          {
            backgroundColor: '#AB8BE0',
            barThickness: 8,
            borderWidth: 0,
            borderRadius: 8,
            label: `Nombre de naissances de bébés portant le prénom ${this.$options.firstname} par décennie depuis 1900`,
            data: Object.values(this.$options.data),
          },
        ],
      },
      options: {
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            grid: {
              color: 'rgba(0, 0, 0, 0.1)',
              borderDash: [1, 1],
            },
          },
        },
      },
      plugins: {
        tooltip: {
          enabled: false,
        },
      },
    });
  }
}
